import { render, staticRenderFns } from "./PcRoList.vue?vue&type=template&id=2fbe1ad0&"
import script from "./PcRoList.vue?vue&type=script&lang=js&"
export * from "./PcRoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports